/**
 * Admin Feature - Constants
 */

// Rotas do admin
export const ADMIN_ROUTES = {
	LOGIN: '/admin/login',
	DASHBOARD: '/admin',
	USERS: '/admin/users',
	USER_DETAIL: '/admin/users/:id',
	CLUBS: '/admin/clubs',
	CLUB_DETAIL: '/admin/clubs/:id',
	MATCHES: '/admin/matches',
	MATCH_DETAIL: '/admin/matches/:id',
	FEEDBACKS: '/admin/feedbacks',
	RATINGS: '/admin/ratings',
	INVITATIONS: '/admin/invitations',
	BROADCAST: '/admin/broadcast',
	LOGS: '/admin/logs',
	SETTINGS: '/admin/settings',
}

// Menu items do sidebar
export const SIDEBAR_ITEMS = [
	{
		id: 'dashboard',
		label: 'Dashboard',
		icon: 'LayoutDashboard',
		path: ADMIN_ROUTES.DASHBOARD,
	},
	{
		id: 'users',
		label: 'Usuários',
		icon: 'Users',
		path: ADMIN_ROUTES.USERS,
	},
	{
		id: 'clubs',
		label: 'Clubes',
		icon: 'Building2',
		path: ADMIN_ROUTES.CLUBS,
	},
	{
		id: 'matches',
		label: 'Partidas',
		icon: 'Calendar',
		path: ADMIN_ROUTES.MATCHES,
	},
	{
		id: 'feedbacks',
		label: 'Feedbacks',
		icon: 'MessageSquare',
		path: ADMIN_ROUTES.FEEDBACKS,
	},
	{
		id: 'ratings',
		label: 'Avaliações',
		icon: 'Star',
		path: ADMIN_ROUTES.RATINGS,
	},
	{
		id: 'invitations',
		label: 'Convites',
		icon: 'Mail',
		path: ADMIN_ROUTES.INVITATIONS,
	},
	{
		id: 'broadcast',
		label: 'Broadcast',
		icon: 'Megaphone',
		path: ADMIN_ROUTES.BROADCAST,
	},
	{
		id: 'logs',
		label: 'Logs',
		icon: 'FileText',
		path: ADMIN_ROUTES.LOGS,
	},
]

// Status de partidas
export const MATCH_STATUS = {
	SCHEDULED: 'scheduled',
	IN_PROGRESS: 'in_progress',
	COMPLETED: 'completed',
	CANCELLED: 'cancelled',
}

export const MATCH_STATUS_LABELS = {
	[MATCH_STATUS.SCHEDULED]: 'Agendada',
	[MATCH_STATUS.IN_PROGRESS]: 'Em andamento',
	[MATCH_STATUS.COMPLETED]: 'Concluída',
	[MATCH_STATUS.CANCELLED]: 'Cancelada',
}

export const MATCH_STATUS_COLORS = {
	[MATCH_STATUS.SCHEDULED]: 'blue',
	[MATCH_STATUS.IN_PROGRESS]: 'green',
	[MATCH_STATUS.COMPLETED]: 'gray',
	[MATCH_STATUS.CANCELLED]: 'red',
}

// Roles de usuário
export const USER_ROLES = {
	USER: 'user',
	ADMIN: 'admin',
	SUPERADMIN: 'superadmin',
}

export const USER_ROLE_LABELS = {
	[USER_ROLES.USER]: 'Usuário',
	[USER_ROLES.ADMIN]: 'Administrador',
	[USER_ROLES.SUPERADMIN]: 'Super Admin',
}

export const USER_ROLE_COLORS = {
	[USER_ROLES.USER]: 'gray',
	[USER_ROLES.ADMIN]: 'blue',
	[USER_ROLES.SUPERADMIN]: 'purple',
}

// Tipos de broadcast
export const BROADCAST_TYPES = {
	PUSH: 'push',
	EMAIL: 'email',
	BOTH: 'both',
}

export const BROADCAST_TYPE_LABELS = {
	[BROADCAST_TYPES.PUSH]: 'Push Notification',
	[BROADCAST_TYPES.EMAIL]: 'Email',
	[BROADCAST_TYPES.BOTH]: 'Push + Email',
}

// Audiências de broadcast
export const BROADCAST_AUDIENCES = {
	ALL: 'all',
	ACTIVE: 'active',
	INACTIVE: 'inactive',
	FILTERED: 'filtered',
}

export const BROADCAST_AUDIENCE_LABELS = {
	[BROADCAST_AUDIENCES.ALL]: 'Todos os usuários',
	[BROADCAST_AUDIENCES.ACTIVE]: 'Usuários ativos (30 dias)',
	[BROADCAST_AUDIENCES.INACTIVE]: 'Usuários inativos (30+ dias)',
	[BROADCAST_AUDIENCES.FILTERED]: 'Filtro personalizado',
}

// Níveis de log
export const LOG_LEVELS = {
	INFO: 'info',
	WARNING: 'warning',
	CRITICAL: 'critical',
}

export const LOG_LEVEL_COLORS = {
	[LOG_LEVELS.INFO]: 'blue',
	[LOG_LEVELS.WARNING]: 'yellow',
	[LOG_LEVELS.CRITICAL]: 'red',
}

// Status de feedback
export const FEEDBACK_STATUS = {
	PENDING: 'pending',
	IN_PROGRESS: 'in_progress',
	RESOLVED: 'resolved',
	CLOSED: 'closed',
}

export const FEEDBACK_STATUS_LABELS = {
	[FEEDBACK_STATUS.PENDING]: 'Pendente',
	[FEEDBACK_STATUS.IN_PROGRESS]: 'Em análise',
	[FEEDBACK_STATUS.RESOLVED]: 'Resolvido',
	[FEEDBACK_STATUS.CLOSED]: 'Fechado',
}

export const FEEDBACK_STATUS_COLORS = {
	[FEEDBACK_STATUS.PENDING]: 'yellow',
	[FEEDBACK_STATUS.IN_PROGRESS]: 'blue',
	[FEEDBACK_STATUS.RESOLVED]: 'green',
	[FEEDBACK_STATUS.CLOSED]: 'gray',
}

// Tipos de feedback
export const FEEDBACK_TYPES = {
	BUG: 'bug',
	FEATURE: 'feature',
	SUPPORT: 'support',
	OTHER: 'other',
}

export const FEEDBACK_TYPE_LABELS = {
	[FEEDBACK_TYPES.BUG]: 'Bug',
	[FEEDBACK_TYPES.FEATURE]: 'Sugestão',
	[FEEDBACK_TYPES.SUPPORT]: 'Suporte',
	[FEEDBACK_TYPES.OTHER]: 'Outro',
}

// Estados brasileiros
export const BRAZILIAN_STATES = [
	{ value: 'AC', label: 'Acre' },
	{ value: 'AL', label: 'Alagoas' },
	{ value: 'AP', label: 'Amapá' },
	{ value: 'AM', label: 'Amazonas' },
	{ value: 'BA', label: 'Bahia' },
	{ value: 'CE', label: 'Ceará' },
	{ value: 'DF', label: 'Distrito Federal' },
	{ value: 'ES', label: 'Espírito Santo' },
	{ value: 'GO', label: 'Goiás' },
	{ value: 'MA', label: 'Maranhão' },
	{ value: 'MT', label: 'Mato Grosso' },
	{ value: 'MS', label: 'Mato Grosso do Sul' },
	{ value: 'MG', label: 'Minas Gerais' },
	{ value: 'PA', label: 'Pará' },
	{ value: 'PB', label: 'Paraíba' },
	{ value: 'PR', label: 'Paraná' },
	{ value: 'PE', label: 'Pernambuco' },
	{ value: 'PI', label: 'Piauí' },
	{ value: 'RJ', label: 'Rio de Janeiro' },
	{ value: 'RN', label: 'Rio Grande do Norte' },
	{ value: 'RS', label: 'Rio Grande do Sul' },
	{ value: 'RO', label: 'Rondônia' },
	{ value: 'RR', label: 'Roraima' },
	{ value: 'SC', label: 'Santa Catarina' },
	{ value: 'SP', label: 'São Paulo' },
	{ value: 'SE', label: 'Sergipe' },
	{ value: 'TO', label: 'Tocantins' },
]
